import React from "react";

export default function Web_AJAX() {
  return (
    <div>
      <h1>What is AJAX</h1>
      <p>
        Route: <code>/web/ajax</code>
      </p>
      <p>Auto-generated component.</p>
    </div>
  );
}
